var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 42C32.5979 42 42 32.5979 42 21C42 9.40212 32.5979 0 21 0C9.40212 0 0 9.40212 0 21C0 32.5979 9.40212 42 21 42ZM10.5 14.28C10.6705 22.465 14.763 27.384 21.9379 27.384H22.3444V22.701C24.9812 22.9635 26.9745 24.8917 27.775 27.384H31.5C30.4769 23.6586 27.788 21.5993 26.1089 20.8123C27.788 19.8416 30.1489 17.4804 30.7129 14.28H27.3286C26.594 16.8773 24.4171 19.2381 22.3444 19.4611V14.28H18.9605V23.3566C16.8617 22.832 14.212 20.2877 14.0935 14.28H10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVk);
export default __webpack_public_path__ + "static/media/icon-vk.03e4ce347bcb6ad1c65102ccb1509aaf.svg";
export { ForwardRef as ReactComponent };